import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { ILoanDetails } from '../../shared/models/loan/loan-details.model';

function createInitialState(): ILoanDetails {
  return <ILoanDetails>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-loan-banner-details-store' })
export class CmgLoanBannerDetailsStore extends Store<ILoanDetails> {
  constructor() {
    super(createInitialState());
  }
}
